import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Reset scroll to the top on every route change.
 *
 * Without this, react-router preserves the window scroll position across
 * navigations — so clicking a link while scrolled down lands you partway
 * down the destination page (e.g. the bottom of /pricing). Hash links are
 * left alone so in-page anchors still work.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
